<template>
  <div class="center-item-body">
    <div class="certify-body">
      <Form ref="certifyBean" :model="certifyBean" :rules="certifyRule"  :label-width="80"
       class="certify-form-body" v-if="showCertifyState != 1">
        <FormItem prop="user_info_real_name" label="真实姓名 :">
          <Input type="text" style="width: 250px;" v-model="certifyBean.user_info_real_name" placeholder="请输入真实姓名"></Input>
        </FormItem>
        <FormItem prop="user_info_id_card" label="身份证号 :">
          <Input type="text" style="width: 250px;" v-model="certifyBean.user_info_id_card" placeholder="请输入身份证号"></Input>
        </FormItem>
      </Form>
      <div v-if="showCertifyState == 1">
        <p class="certify-p-body" style="margin-top: 60px;">真实姓名 : <span>{{certifyBean.user_info_real_name}}</span></p>
        <p class="certify-p-body" style="margin-top: 30px;">身份证号 : <span>{{certifyBean.user_info_id_card}}</span></p>
      </div>
      <p class="trip-body">
        <span style="margin-left: 20px;">根据政府相关规定,</span>
        <span class="trip-text-red">未满18周岁</span>
        的玩家将被纳入防沉迷范围;届时被纳入防沉迷的玩家,游戏收益
        将会受损;未填写身份证的玩家将不能进行游戏,请各位玩家尽快填写姓名、身份证信息,以便顺畅游戏。
        <span class="trip-text-red">此账号的身份证信息只能填写一次，是判断账号归属的重要依据。</span>
      </p>
      <div class="certify-submit" @click="updateCertify('certifyBean')" v-if="showCertifyState != 1">确认绑定</div>
    </div>
  </div>
</template>
 
<script>
export default {
  data() {
    const validateName = (rule, value, callback) => {
      let reg = /^[\u4E00-\u9FA5]{2,10}(·[\u4E00-\u9FA5]{2,10}){0,2}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("*请输入真实姓名"));
      }
    };
    const validateIdCard = (rule, value, callback) => {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("*请输入真实身份证号码"));
      }
    };
    return {
      loginState:false,
      //1 认证 2 未认证 0 未填写
      showCertifyState:0,
      certifyBean: {
        user_info_id_card:"", 
        user_info_real_name:""
      },
      certifyRule: {
        user_info_real_name: [
          {  validator: validateName, trigger: "blur" }
        ],
        user_info_id_card:[
          {  validator: validateIdCard, trigger: "blur" }
        ],
      },
    };
  },
  mounted(){
    if (window.sessionStorage.getItem("token") !== null) {
      this.loginState = true;
    } 
    this.queryMineCertify();
  },
  methods:{
    queryMineCertify(){
      this.$http.post(`/query_web_mine_certify`,{})
      .then(res=>{
        if(res.data.code == 2000){
          this.certifyBean=res.data.data;
          this.showCertifyState = this.certifyBean.user_info_certify_state;
        }else{
          alert(res.data.msg);
        }
      })
    },
    updateCertify(name) {
      this.$refs[name].validate((valid) => {
        this.$http.post(`/update_web_mine_certify`,{   
          data:this.certifyBean
        }).then(res=>{       
          if (res.data.code==2000) {
            alert('信息更新成功!');
            this.queryMineCertify();
          } else {
            alert(res.data.msg);
          }
        })   
      })
    },
  },
  watch:{
    loginState(value){
      if(value){
        this.queryMineCertify();
      }
    }
  }
};
</script>
<style src="@/assets/css/mine_center.css" scoped></style>